import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getPlans } from '@custom/rtk-apis/Setting/plans/getPlans';

// Define the PlanConfig interface for monthly and yearly plans
export interface PlanConfig {
  centers: string;
  radiologists: string;
  casesPerMonth: number;
  extraCaseRate: number;
  cloudStorage: string;
  radiologistId: string;
  centerInstallations: string;
  showPublic: boolean;
}

// Define the Plan interface
export interface Plan {
  _id?: string;
  name: string;
  monthly: PlanConfig;
  yearly: PlanConfig;
  recommended?: boolean; // Flag to mark a plan as recommended
}

// Define the state interface
export interface PlansState {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  success: boolean;
}

// Initial state
const initialState: PlansState = {
  plans: [],
  loading: false,
  error: null,
  success: false
};

// Create the slice
const getPlansSlice = createSlice({
  name: 'getPlans',
  initialState,
  reducers: {
    resetSuccess: (state) => {
      state.success = false;
    },
    resetError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlans.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getPlans.fulfilled, (state, action: PayloadAction<any[]>) => {
        state.loading = false;
        state.plans = action.payload;
        state.success = true;
      })
      .addCase(getPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export default getPlansSlice.reducer;
export const { resetSuccess, resetError } = getPlansSlice.actions;
